var exports = {
  "JC": "Accordion.module__accordion___STlxRk",
  "U1": "Accordion.module__headerRow___STlxRk",
  "L9": "Accordion.module__headerClickTarget___STlxRk",
  "N4": "Accordion.module__titleButton___STlxRk",
  "Z2": "Accordion.module__descriptionButton___STlxRk",
  "me": "Accordion.module__caretButton___STlxRk",
  "VW": "Accordion.module__headerContent___STlxRk",
  "$": "Accordion.module__titleRow___STlxRk",
  "QE": "Accordion.module__headerAction___STlxRk",
  "ID": "Accordion.module__compactTitle___STlxRk",
  "SY": "Accordion.module__compactDescription___STlxRk",
  "OW": "Accordion.module__caret___STlxRk",
  "bd": "Accordion.module__caretExpanded___STlxRk",
  "FG": "Accordion.module__contentWrapper___STlxRk",
  "Qs": "Accordion.module__content___STlxRk",
};

module.exports = exports;
